<template>
  <div>
    <div class="filters-section">
      <span v-if="!Array.isArray(regReport)" class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'report')"
            type="radio"
            name="report_filters"
            id="keyword"
            value="keyword"
            checked
          />
          <label class="filter-title" for="keyword">KEYWORD</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'report')"
            type="radio"
            name="report_filters"
            id="campaign_aaid"
            value="campaign_aaid"
          />
          <label class="filter-title" for="campaign_aaid">CAMPAIGN</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'report')"
            type="radio"
            name="report_filters"
            id="device"
            value="device"
          />
          <label class="filter-title" for="device">DEVICE</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'report')"
            type="radio"
            name="report_filters"
            id="country_id"
            value="country_id"
          />
          <label class="filter-title" for="country_id">COUNTRY</label>
        </div>
      </span>
      <span v-if="!Array.isArray(regReport)" class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'client')"
            type="radio"
            name="filters"
            id="REG"
            value="REG"
            checked
          />
          <label class="filter-title" for="REG">REG</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'client')"
            type="radio"
            name="filters"
            id="DUP"
            value="DUP"
          />
          <label class="filter-title" for="DUP">DUP</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'client')"
            type="radio"
            name="filters"
            id="ALL"
            value="ALL"
          />
          <label class="filter-title" for="ALL">ALL</label>
        </div>
      </span>
      <span v-if="!Array.isArray(regReport)" class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'tier')"
            type="radio"
            name="tier-filters"
            id="ALL-tier"
            value="ALL"
            checked
          />
          <label class="filter-title" for="ALL-tier">ALL</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'tier')"
            type="radio"
            name="tier-filters"
            id="T1"
            value="T1"
          />
          <label class="filter-title" for="T1">T1</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'tier')"
            type="radio"
            name="tier-filters"
            id="T2"
            value="T2"
          />
          <label class="filter-title" for="T2">T2</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event, 'tier')"
            type="radio"
            name="tier-filters"
            id="T3"
            value="T3"
          />
          <label class="filter-title" for="T3">T3</label>
        </div>
      </span>
    </div>
    <div v-if="!Array.isArray(regReport)" class="weekend-toggle">
      <span class="weekends-toggle-title">WEEKENDS</span>
      <span class="toggler">
        <label class="switch">
          <input
            v-model="weekendToggle"
            value="!weekendToggle"
            type="checkbox"
            checked
          />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <div v-if="!Array.isArray(regReport)" class="weekend-toggle">
      <span class="weekends-toggle-title">LIVE REPORT</span>
      <span class="toggler">
        <label class="switch">
          <input
            v-model="liveToggle"
            value="!liveToggle"
            type="checkbox"
            checked
          />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <div
      class="report-table"
      v-if="!Array.isArray(regReport) && !regReportBusy"
    >
      <table id="registration-table">
        <thead>
          <tr>
            <th>
              Name
              <button
                v-on:click="applySorting(0, 0)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                    'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th
              v-for="(date, key) in regReport['dates_total']"
              :key="date"
              :class="{ 'weekend-date': date.is_weekend }"
            >
              {{ date.id }}
              <button
                v-on:click="applySorting(1, key + 1, true)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="total-sum">
              Average
              <button
                v-on:click="
                  applySorting(1, regReport['dates_total'].length + 1)
                "
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="total-sum">
              Total
              <button
                v-on:click="
                  applySorting(1, regReport['dates_total'].length + 2)
                "
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="total-sum">
              Estimate
              <button
                v-on:click="
                  applySorting(1, regReport['dates_total'].length + 3)
                "
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="total-sum">Total</td>
            <td
              v-for="date in regReport['dates_total']"
              :style="calculateScaleColor(date.total)"
              :class="{
                'exclude-weekend': date.is_weekend && !weekendToggle
              }"
              :key="date"
            >
              {{ date.total }}
            </td>
            <td class="total-sum">
              {{ getSumOfAvg() }}
            </td>
            <td class="total-sum">{{ getSumOfTotals() }}</td>
            <td class="total-sum">{{ getTotalEstimate() }}</td>
          </tr>
          <tr v-for="user in regReport['group']" :key="user">
            <td>
              {{ user.id | truncate(15) }}
            </td>
            <td
              class="td-hover"
              :style="calculateScaleColor(date.amount)"
              :class="{
                'exclude-weekend':
                  regReport['dates_total'][key].is_weekend && !weekendToggle
              }"
              v-for="(date, key) in user['dates']"
              :key="date"
            >
              <span :class="{ invisible: date.amount === 0 }">{{
                date.amount
              }}</span>
            </td>
            <td :style="calculateScaleColor(getTotalBasedOnToggle(user))">
              {{ calculateAvgSumOfUser(getTotalBasedOnToggle(user)) }}
            </td>
            <td :style="calculateScaleColor(getTotalBasedOnToggle(user))">
              {{ getTotalBasedOnToggle(user) }}
            </td>
            <td :style="calculateScaleColor(getTotalBasedOnToggle(user))">
              {{ getEstimateAmount(getTotalBasedOnToggle(user)) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="loader-div" v-if="regReportBusy">
      <!--      <loader :size="'8px'"></loader>-->
      <span class="insteadLoader"
        >CREATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import moment from "moment";

export default {
  name: "RegistrationReport.container",
  // components: { Loader },
  mixins: [UsersPermissionCheck],

  data() {
    return {
      regReport: [],
      liveReport: [],
      regReportBusy: false,
      liveToggle: false,
      weekendToggle: false,
      dateOfReport: null,
      filtersObject: {
        client: "REG",
        report: "keyword",
        tier: "ALL"
      },
      overallReport: [],
      sortOrder: {
        0: "desc",
        1: "desc"
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.getUserDepositsStats();
  },
  watch: {
    liveToggle: function() {
      if (this.liveToggle) {
        this.getLiveUserDepositsStats();
      } else {
        this.regReport = this.overallReport[this.filtersObject["client"]][
          this.filtersObject["tier"]
        ][this.filtersObject["report"]];
        this.dateOfReport = moment()
          .startOf("month")
          .add(this.regReport["dates_total"].length - 1, "days")
          .format("YYYY-MM-DD");
      }
    }
  },
  methods: {
    async getUserDepositsStats() {
      if (!this.regReportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.regReportBusy = true;
          const res = await apiClientCreator(
            `reports/campaigns/registrations_report`
          ).get("");
          this.overallReport = res.data;
          this.regReport = this.overallReport["REG"]["ALL"]["keyword"];
          this.regReportBusy = false;
        } catch (e) {}
      }
    },
    async getLiveUserDepositsStats() {
      if (!this.regReportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.regReportBusy = true;
          const res = await apiClientCreator(
            `reports/campaigns/live_registrations_report`
          ).get("", { params: this.filtersObject });
          this.liveReport = res.data;
          this.regReport = this.mergeReports();
          this.dateOfReport = moment()
            .startOf("month")
            .add(this.regReport["dates_total"].length - 1, "days")
            .format("YYYY-MM-DD");
          this.regReportBusy = false;
        } catch (e) {}
      }
    },
    mergeReports() {
      let tempSaved = JSON.parse(
        JSON.stringify(
          this.overallReport[this.filtersObject["client"]][
            this.filtersObject["tier"]
          ][this.filtersObject["report"]]
        )
      );

      let tempLive = this.liveReport[this.filtersObject["client"]][
        this.filtersObject["tier"]
      ][this.filtersObject["report"]];
      tempLive["dates_total"].forEach(item => {
        tempSaved["dates_total"].push(item);
      });
      for (let key in tempSaved["group"]) {
        if (tempLive["group"][key] !== undefined) {
          // Append the total and total workdays
          tempSaved["group"][key]["total"] += tempLive["group"][key]["total"];
          tempSaved["group"][key]["total_workday"] +=
            tempLive["group"][key]["total_workday"];

          // Add each additional date to the overall array of saved dates
          tempLive["group"][key]["dates"].forEach(item => {
            tempSaved["group"][key]["dates"].push(item);
          });
        } else {
          let dateId =
            "0" +
            String(
              Number(
                tempSaved["group"][key]["dates"][
                  tempSaved["group"][key]["dates"].length - 1
                ]["id"]
              ) + 1
            );
          tempSaved["group"][key]["dates"].push({ id: dateId, amount: 0 });
        }
      }
      for (let key in tempLive["group"]) {
        if (tempSaved["group"][key] === undefined) {
          let lastDate = Number(
            tempLive["group"][key]["dates"][
              tempLive["group"][key]["dates"].length - 1
            ]["id"]
          );
          while (lastDate > 1) {
            let item = { id: "0" + String(lastDate - 1), amount: 0 };
            tempLive["group"][key]["dates"].unshift(item);
            lastDate--;
          }
          tempSaved["group"][key] = tempLive["group"][key];
        }
      }
      return tempSaved;
    },
    changeFilter(event, group) {
      this.filtersObject[group] = event.target.value;
      if (!this.liveToggle) {
        this.regReport = this.overallReport[this.filtersObject["client"]][
          this.filtersObject["tier"]
        ][this.filtersObject["report"]];
      } else {
        this.getLiveUserDepositsStats();
      }
    },
    calculateAvgSumOfUser(amount) {
      let currentDay = moment().date();
      return (amount / currentDay).toFixed(2);
    },
    getSumOfTotals() {
      let sum = 0;
      this.regReport["dates_total"].forEach(item => {
        sum += this.getTotalBasedOnToggle(item);
      });
      return sum;
    },
    getSumOfAvg() {
      let sum = 0;
      for (const i in this.regReport["group"]) {
        sum += Number(
          this.calculateAvgSumOfUser(
            this.getTotalBasedOnToggle(this.regReport["group"][i])
          )
        );
      }
      return sum.toFixed(2);
    },
    getEstimateAmount(amount) {
      let workDaysCount = 0;
      let workDaysCountUntilNow = 0;
      let currentDate = moment().format("YYYY-MM-DD");
      let startOfMonth = moment().startOf("month");
      let endOfMonth = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      if (amount > 0) {
        while (startOfMonth.format("YYYY-MM-DD") <= endOfMonth) {
          if (!this.weekendToggle) {
            if (
              startOfMonth.weekday() !== 6 &&
              startOfMonth.weekday() !== 7 &&
              startOfMonth.weekday() !== 0
            ) {
              workDaysCount++;
              if (startOfMonth.format("YYYY-MM-DD") <= currentDate) {
                workDaysCountUntilNow++;
              }
            }
          } else {
            workDaysCount++;
            if (startOfMonth.format("YYYY-MM-DD") <= currentDate) {
              workDaysCountUntilNow++;
            }
          }
          startOfMonth.add(1, "day");
        }
      }
      return Number(
        (amount / Math.max(workDaysCountUntilNow, 1)) * workDaysCount
      ).toFixed(1);
    },
    getTotalEstimate() {
      let totalSum = 0;
      for (let i in this.regReport["group"]) {
        totalSum += Number(
          this.getEstimateAmount(
            this.getTotalBasedOnToggle(this.regReport["group"][i])
          )
        );
      }
      return totalSum.toFixed(1);
    },
    getTotalBasedOnToggle(user) {
      return this.weekendToggle ? user["total"] : user["total_workday"];
    },
    calculateScaleColor(value) {
      let r, g, b;

      if (value === 0) {
        return {
          background: `rgb(211,211,211)`
        };
      }
      if (value < 4) {
        // yellow to red
        r = 255;
        g = Math.floor(255 * (value / 4));
      } else {
        // yellow to green
        r = Math.floor(255 * (4 / value));
        g = 255;
      }
      b = 0;

      return {
        background: `rgb(${r},${g},${b})`
      };
    },
    applySorting(typeSort, tableColumn, innerTableSort = false) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById("registration-table");
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 2; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (innerTableSort) {
            x = x.getElementsByTagName("SPAN")[0];
            y = y.getElementsByTagName("SPAN")[0];
          }
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
table tr:hover:nth-of-type(1) {
  background: none;
}
/*table tr:hover {*/
/*  background: lightgreen;*/
/*}*/
table tr:hover .td-hover {
  border: 2px solid transparent;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.3em 0.75em;
  text-align: center;
}
th {
  font-size: smaller;
}
.report-table {
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  height: 750px;
  padding-bottom: 3em;
}
.loader-div {
  padding-top: 5em;
}
.total-sum {
  background-color: lightgreen;
}
.invisible {
  visibility: hidden;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
  background: transparent;
}
.btn-sm:active {
  border: none;
  outline: none;
}
.btn-sm:focus {
  border: none;
  outline: none;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 15px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 9px;
  width: 9px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.weekend-toggle {
  padding-right: 4.5vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.weekends-toggle-title {
  font-size: 9px;
}
.toggler {
  padding-right: 0.5em;
}
.filters-section {
  padding-top: 1em;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.weekend-date {
  background-color: #f9a825;
}
.exclude-weekend {
  opacity: 0.4;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 35%;
  top: 158px;
}
</style>
